import React, { useEffect } from 'react';
import { MotionConfig } from 'framer-motion';
import { initMetaPixel } from './utils/metaPixel';
import { CountdownBar } from './components/CountdownBar';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { Difference } from './components/Difference';
import { Recognize } from './components/Recognize';
import { WhatsInside } from './components/WhatsInside';
import { InsidePages } from './components/InsidePages';
import { Bonuses } from './components/Bonuses';
import { HowItWorks } from './components/HowItWorks';
import { Audience } from './components/Audience';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    document.documentElement.lang = 'en';
    document.title = 'DRUM READY™ – Your Whole Drum Studio Year, Already Planned';
  }, []);
  return <MotionConfig reducedMotion="user" data-id="element-0" data-mp="3mk83iqmq9x9u">
      <div lang="en" className="w-full bg-stone-50 font-sans text-slate-900 antialiased" data-id="element-1" data-mp="3rc9em985thya">
        <CountdownBar data-id="element-2" data-mp="3relumgucxi8p" />
        <main data-id="element-3" data-mp="5os92t1uy7l">
          <Hero data-id="element-4" data-mp="680tswt8a8y" />
          <StatsBar data-id="element-5" data-mp="4n5i12o8na1" />
          <Difference data-id="element-6" data-mp="56l3b4umzkw" />
          <Recognize data-id="element-7" data-mp="2zl3a7gleoy37" />
          <WhatsInside data-id="element-8" data-mp="2zllduyaeeel5" />
          <InsidePages data-id="element-9" data-mp="2zmepackaxs9m" />
          <Bonuses data-id="element-10" data-mp="2zmwh8wzxlkbq" />
          <HowItWorks data-id="element-11" data-mp="2znfy0adui2o6" />
          <Audience data-id="element-12" data-mp="33m5cy7ej7s9x" />
          <Offer data-id="element-13" data-mp="33nq55qddiz4m" />
          <Guarantee data-id="element-14" data-mp="33n6wz1dizp3s" />
          <Testimonials data-id="element-15" data-mp="33oi3h8ycvayl" />
          <Faq data-id="element-16" data-mp="38m1jadapbvsn" />
          <FinalCta data-id="element-17" data-mp="38li77d7qg1mj" />
        </main>
        <Footer data-id="element-18" data-mp="38kgk2adfzoog" />
      </div>
    </MotionConfig>;
}